import { Button } from '@mui/material';
import RoleConfigurationTable from '../../../components/commonComponent/RoleConfigurationTable';
import { useEffect, useState } from 'react';
import axiosInstance from '../../../api/axios';
import { BASE_URL } from '../../../constants/apiConstants';
import Loader from '../../../components/loader/Loader';
import AddRoleModal from '../../../components/commonComponent/AddRoleModal';

type Role = {
  roleid: number;
  rolename: string;
  isactive: string;
};

type RoleResponse = {
  success: boolean;
  message: string;
  data: Role[];
  responsecode: number;
  errormessage: string | null;
};

const RoleConfiguration = () => {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [data, setData] = useState<RoleResponse | null>(null);
  const [loading, setLoading] = useState(false);

  const fetchRoles = async () => {
    try {
      setLoading(true);
      const res = await axiosInstance.get<RoleResponse>(`${BASE_URL}/api/v1/Role/GetAllRole`);
      setData(res.data);
    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRoles();
  }, []);

  const handleOpenModal = () => {
    setOpenModal(true);
  };
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const handleOkeModal = () => {
    setOpenModal(false);
    fetchRoles();
  };

  return (
    <div className="content-wrapper">
      <div className='flex justify-content-between mb-8'>
        <h1 className="flex align-items-center mb-0">Role Configuration</h1>
        <Button className={`primary-btn`} onClick={handleOpenModal}>
          Add
        </Button>
      </div>
      <div className="white-box mb-12">
        <div className="inner-contant kitchen-dashboard">
          <RoleConfigurationTable roles={data?.data ?? []} fetchRoles={fetchRoles} />
          {loading && <Loader />}
          {openModal && (
            <AddRoleModal
              open={openModal}
              handleClose={handleCloseModal}
              handleOk={handleOkeModal}
              title="Add Role"
              closeText="Cancel"
              submitText="Save"
              roleList={data?.data ?? []} // Pass existing roles
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default RoleConfiguration;
